import React from 'react';

import './style.scss'

const LocalMap = ({
    handleClick,
    selectedRegion,
}) => {
    return (
        <>
            <div className="local-map">
                <svg
                width="540"
                height="760"
                viewBox="0 0 540 760"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                    {/* .local에 지역명을 class로 입력시 해당 지역의 색이 들어갑니다. 
                        강원: gangwon, 경기: gyeonggi, 경남: gyeongnam, 경북: gyeongbuk, 광주: gwangju,
                        대구: daegu, 울산: ulsan, 인천: incheon, 전남: jeonnam, 전북: jeonbuk,
                        제주: jeju, 충남: chungnam , 충북: chungbuk
                    */}
                    <g>
                        {/* 강화도 */}
                        <svg x="73" y="170" width="23" height="19" viewBox="0 0 23 19" fill="none">
                            <path d="M12.3124 0.13269L0.948608 10.5238V17.0763L9.90403 18.3261L22.0884 10.5238L21.1251 0.13269H12.3124Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    {/* 인천 */}
                    <g
                        className={'local incheon ' + (selectedRegion === "인천" ? "active" : "")}
                    >
                        <svg
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("인천", e)}
                            onKeyDown={(e) => handleClick("인천", e)}
                            x="94" y="153" width="28" height="46" viewBox="0 0 28 46" fill="none">
                            <path d="M3.92574 30.0606L3.51351 30.6997L4.01934 31.2677L11.9222 40.1412L11.9676 40.1922L12.0195 40.2365L16.2831 43.8787L17.051 44.5347L17.6994 43.7604L25.1741 34.8333L25.4074 34.5547V34.1913V25.4648L26.6887 9.41784L26.7573 8.55765L25.9165 8.3638L16.5213 6.19797L8.951 2.11963L8.39084 1.81785L7.88017 2.19742L2.40345 6.26819L1.66647 6.81598L2.14959 7.59689L10.1126 20.4681L3.92574 30.0606Z"
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("인천", e)}
                            onKeyDown={(e) => handleClick("인천", e)}
                            x="99" y="168" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 경기 */}
                    <g
                        className={'local gyeonggi ' + (selectedRegion === "경기" ? "active" : "")}
                    >
                        <svg
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("경기", e)}
                            onKeyDown={(e) => handleClick("경기", e)}
                            x="55" y="59" width="193" height="213" viewBox="0 0 193 213" fill="none">
                            <path d="M83.2776 2H105.345L111.25 5.37444L113.284 16.6583L125.682 18.7651L138.651 18.4616L148.017 25.514L149.605 38.9225L161.272 54.0807L165.75 73.399L156.491 93.1636L162.199 101.019L181.52 103.287L189.298 107.643L180.307 116.927L182.269 125.569L184.267 133.55L179.201 151.422C179.201 151.422 178.291 158.51 181.02 161.402L164.519 186.023L158.061 189.737L155.456 187.059L134.102 197.95L133.87 198.075L130.427 203.824L129.196 201.86L114.193 197.271L102.58 203.181H86.4352L75.232 209.519L53.1824 160.045L67.6859 147.869L57.0179 138.763L64.9208 129.336V119.981L66.1696 106.786L70.8079 109.572L77.8366 121.302L89.8069 126.962L110.411 125.462L118.082 108.75L111.607 103.644L106.237 90.5568L91.466 84.7721L72.9486 92.1102L67.454 94.5383L64.0288 95.8417L64.4035 102.019L55.6265 100.02L47.0457 95.3953L40.7127 100.109L39.0179 97.4128L23.9257 98.8591L3 86.1647L10.0466 66.3644L29.6522 78.8088L40.891 77.1126L54.8237 95.7881L60.8356 93.6813L40.4807 66.0787L42.8891 40.6722L83.242 2.05356L83.2776 2Z" 
                                // fill={selectedRegion === "경기" ? "#024383" : "#BADBF0"} 
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                            <text
                                x="64%"
                                y="76.5%"
                                fontSize="16px"
                                fill={selectedRegion === "경기" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                경기
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("경기", e)}
                            onKeyDown={(e) => handleClick("경기", e)}
                            x="164" y="208" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 강원 */}
                    <g
                        className={'local gangwon ' + (selectedRegion === "강원" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("강원", e)}
                            onKeyDown={(e) => handleClick("강원", e)}
                            x="133" y="1" width="310" height="244" viewBox="0 0 310 244" fill="none">
                            <path d="M25.89 59.9549L32.9188 63.9721L34.8633 74.8453L45.8524 76.72L59.2677 76.3808L69.7395 84.2545L71.3628 97.9308L83.012 113.196L87.6681 133.318L78.5878 152.69L83.2083 159.064L102.261 161.367L112.215 166.955L102.279 177.221L104.027 184.899L106.15 193.326L100.976 211.519C100.976 211.519 100.298 218.839 104.241 221.785C108.219 224.767 119.208 225.66 120.992 225.428C121.563 224.714 123.365 221.535 124.81 218.947C130.429 208.948 131.125 208.145 132.249 208.52C133.444 208.913 139.635 212.233 141.329 216.376C142.649 219.625 151.177 222.75 158.758 220.339C166.768 217.804 185.803 217.768 186.624 217.768H187.034L191.208 222.75L186.731 229.873L203.553 237.301L214.079 242.925L224.336 244.389L238.608 239.14L255.431 242.943L272.36 235.551L280.602 237.854L294.874 227.124L307.022 223.071L292.001 185.113L184.644 3L168.088 4.80327L168.802 16.8906L147.002 38.5656L20.0565 45.4573L5 59.9371H25.89V59.9549Z" 
                                // fill={selectedRegion === "강원" ? "#024383" : "#8FC4E7"} 
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                            <text
                                x="52%"
                                y="57.5%"
                                fontSize="16px"
                                fill={selectedRegion === "강원" ? "#none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                강원
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("강원", e)}
                            onKeyDown={(e) => handleClick("강원", e)}
                            x="276" y="129" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 충남 */}
                    <g
                        className={'local chungnam ' + (selectedRegion === "충남" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("충남", e)}
                            onKeyDown={(e) => handleClick("충남", e)}
                            x="35" y="249" width="184" height="166" viewBox="0 0 184 166" fill="none">
                            <path d="M65.4033 164.724L65.8084 164.861L66.1874 164.663L82.0467 156.361L82.0573 156.355L82.0678 156.349L103.601 144.412L114.116 146.111L117.032 152.413L117.254 152.893L117.775 152.98L125.589 154.283L125.957 154.344L126.275 154.15L138.268 146.827L148.561 150.451L150.399 162.941L150.525 163.795H151.389H168.854H169.267L169.559 163.503L181.726 151.38L182.091 151.017L182.007 150.509L178.724 130.691L178.613 130.018L177.946 129.876L171.002 128.4L171.7 120.864L174.57 116.299L175.534 114.767H173.724H157.333L148.568 108.818L147.064 100.699L150.01 90.7701L150.115 90.4181L149.967 90.0822L145.079 78.9947L145.027 78.8768L144.947 78.7759L136.747 68.4595L142.386 62.5427L153.227 65.1235L154.108 65.3333L154.404 64.4766L159.987 48.2828L160.042 48.1244V47.9569V33.9592V33.6714L159.889 33.4276L147.383 13.5023L147.185 13.1866L146.829 13.0776L133.164 8.8997L132.777 8.78153L132.417 8.96512L121.285 14.6408H105.488H105.22L104.988 14.7746L94.0728 21.073L90.7387 22.6232L77.5686 8.51308L77.3381 8.26606L77.0049 8.20951L40.5054 2.0141L40.1429 1.95258L39.8269 2.1405L4.79016 22.9764L4.34446 23.2414L4.3043 23.7584L2.003 53.3785L1.95198 54.0353L2.53529 54.3414L21.5522 64.322L21.8153 64.4601L22.1112 64.432L37.9713 62.9291L52.6672 141.36L43.4858 149.644L43.2043 149.898L43.1619 150.275L42.5019 156.149L42.4119 156.95L43.1753 157.208L65.4033 164.724Z" 
                                // fill={selectedRegion === "충남" ? "#024383" : "#499DD8"} 
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                                />
                                <text
                                    x="50%"
                                    y="54%"
                                    fontSize="16px"
                                    fill={selectedRegion === "충남" ? "#none" : "#161616"}
                                    paintOrder="stroke"
                                    fontWeight="bold"
                                >
                                    충남
                                </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("충남", e)}
                            onKeyDown={(e) => handleClick("충남", e)}
                            x="111" y="327" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 충북 */}
                    <g
                        className={'local chungbuk ' + (selectedRegion === "충북" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("충북", e)}
                            onKeyDown={(e) => handleClick("충북", e)}
                            x="182" y="207" width="165" height="202" viewBox="0 0 165 202" fill="none">
                            <path d="M52.9403 14.5487L36.569 38.993L29.4174 43.0967L27.3184 40.9392L26.8043 40.4107L26.1474 40.7456L6.18507 50.9225L5.92861 51.0532L5.78091 51.3003L2.14166 57.3886L1.82746 57.9142L2.15284 58.433L12.8275 75.4527L12.7756 89.9618L7.15506 106.537L7.07002 106.788L7.12023 107.048L10.92 126.723L11.0017 127.145L11.3647 127.377L24.6825 135.859L32.2619 150.13L24.6129 162.317L24.4857 162.52L24.464 162.758L23.8575 169.418L23.7768 170.303L24.6472 170.487L31.4348 171.917L34.7666 192.132L34.8737 192.781L35.513 192.94L65.6617 200.403L66.0309 200.494L66.3675 200.317L80.6569 192.801L95.623 186.407L96.3909 186.079L96.205 185.265L92.2625 168L92.1083 167.325L91.4222 167.232L80.2095 165.709L77.3932 157.351L79.4936 130.593L79.5199 130.259L79.3393 129.976L74.3016 122.095L75.0621 115.034L82.0816 108.576L82.3924 108.29L82.4041 107.867L82.7251 96.2533L86.1109 94.8702L91.8315 97.2474L92.2367 97.4158L92.635 97.2315L96.8809 95.2675L97.3396 95.0554L97.4408 94.5602L100.21 81.0079L119.957 77.8378L121.8 85.8707L121.914 86.3684L122.384 86.5678L126.005 88.1032L126.577 88.3457L127.048 87.9405L137.877 78.6206L138.22 78.3247L138.224 77.871L138.294 69.5388L145.529 52.7643L161.571 35.7704L162.469 34.8186L161.315 34.2019L154.696 30.6668L153.225 29.881V30.0327L137.027 22.8879L141.3 16.0833L141.687 15.4666L141.219 14.9088L138.418 11.5701L138.116 11.2099L137.646 11.2128C136.201 11.2218 131.23 11.28 125.725 11.6186C120.258 11.9549 114.132 12.5739 110.448 13.7412L110.447 13.7416C106.536 14.9872 102.277 14.8464 98.7881 13.8636C97.0463 13.373 95.5262 12.6808 94.3533 11.8744C93.1712 11.0617 92.4013 10.1753 92.0535 9.31901L92.0529 9.3176C91.3339 7.55513 89.6705 5.93449 88.1009 4.70911C86.5054 3.46356 84.84 2.4995 83.9178 2.08712L83.2554 1.7909L82.7683 2.32878C82.447 2.68361 82.0401 3.27367 81.6077 3.94905C81.1632 4.64305 80.6541 5.4876 80.1228 6.39276C79.2583 7.8659 78.3223 9.52211 77.4958 10.9845C77.307 11.3186 77.1239 11.6426 76.9486 11.9521L76.9469 11.9552C75.2472 14.9813 74.267 16.7004 73.6372 17.698C73.321 18.1989 73.1181 18.4773 72.9777 18.6375C72.9108 18.7137 72.8695 18.7499 72.8493 18.7657C72.8397 18.7733 72.8345 18.7765 72.8331 18.7773L72.8306 18.7786C72.8306 18.7786 72.8306 18.7787 72.8304 18.7787C72.8237 18.7806 72.6333 18.8329 72.1369 18.8597C71.684 18.8842 71.0871 18.8835 70.377 18.853C68.9594 18.7923 67.1449 18.6158 65.2309 18.3132C63.316 18.0104 61.322 17.5846 59.5396 17.0313C57.7434 16.4737 56.2339 15.8082 55.2312 15.0579C54.9643 14.8533 54.7135 14.6334 54.4786 14.3983L53.6179 13.537L52.9403 14.5487Z"  
                                // fill={selectedRegion === "충북" ? "#024383" : "#2D8DD2"} 
                                fill="currentColor"
                                stroke="white" strokeWidth="2"/>
                            <text
                                x="27%"
                                y="44%"
                                fontSize="16px"
                                fill={selectedRegion === "충북" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                충북
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("충북", e)}
                            onKeyDown={(e) => handleClick("충북", e)}
                            x="210" y="284" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 경북 */}
                    <g
                        className={'local gyeongbuk ' + (selectedRegion === "경북" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("경북", e)}
                            onKeyDown={(e) => handleClick("경북", e)}
                            x="246" y="222" width="233" height="256" viewBox="0 0 233 256" fill="none">
                            <path d="M218.133 231.49L218.645 231.301L218.764 230.769L230.93 175.992L231.05 175.451L230.655 175.062L226.463 170.938L226.133 170.613L225.672 170.655L207.494 172.29L196.641 160.838L210.29 38.9268L210.317 38.6793L210.226 38.4478L196.061 2.63223L195.713 1.75215L194.815 2.05126L182.702 6.08631L182.546 6.13826L182.415 6.2374L168.217 16.9732L160.201 14.7486L159.859 14.6538L159.534 14.7955L142.959 22.0204L126.42 18.2721L126.132 18.2066L125.854 18.309L111.893 23.4521L101.166 21.8718L98.9635 20.7029L98.2904 20.3457L97.7674 20.8999L81.3908 38.2542L81.2687 38.3836L81.1987 38.5471L74.1165 55.098L74.0358 55.2864V55.4914V63.8529L62.5625 73.7357L58.1289 71.8567L56.3695 64.1425L56.1612 63.2292L55.2362 63.3775L36.7545 66.3413L36.0722 66.4507L35.9333 67.1277L33.1807 80.5403L28.2583 82.8059L22.5259 80.421L22.1452 80.2626L21.7636 80.4185L19.1412 81.4898L18.5374 81.7364L18.5197 82.3884L18.2101 93.8212L11.1711 100.302L10.8941 100.557L10.8541 100.931L10.1583 107.43L10.1209 107.779L10.3103 108.075L15.328 115.918L13.2419 142.846L13.2262 143.049L13.2908 143.241L15.8775 150.954L16.0751 151.544L16.6911 151.627L27.9751 153.159L32.1841 171.594L16.6295 178.23L16.5922 178.246L16.5564 178.264L2.53456 185.638L1.92623 185.958L2.00691 186.641L4.4866 207.619L4.53293 208.011L4.83449 208.266L22.1923 222.924L22.3249 223.036L22.4876 223.097L39.5795 229.481L44.4819 234.562L40.1259 245.225L39.9562 245.64L40.1537 246.043L42.9188 251.685L43.1932 252.245H43.8167H66.3123H66.462L66.6052 252.201L88.0412 245.635L106.302 254.011L106.52 254.111L106.76 254.101L113.753 253.815L115.076 253.761L114.661 252.503L108.099 232.605L111.531 209.073L116.543 201.235H131.493L136.408 214.741L129.881 223.882L129.764 224.046L129.72 224.242L125.484 242.856L122.483 252.115L122.04 253.482L123.476 253.422L127.793 253.244L128.139 253.23L128.402 253.004L137.158 245.507L146.057 247.437L146.299 247.49L146.538 247.423L159.169 243.888L159.426 243.816L159.614 243.625L169.931 233.091L181.394 234.628L186.752 239.271L187.104 239.576L187.565 239.502L203.085 237.02L203.181 237.005L203.273 236.971L218.133 231.49Z"
                                // fill={selectedRegion === "경북" ? "#024383" : "#67ADDD"} 
                                fill="currentColor"
                                stroke="white" strokeWidth="2" />
                            <text
                                x="44%"
                                y="49.5%"
                                fontSize="16px"
                                fill={selectedRegion === "경북" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                경북
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("경북", e)}
                            onKeyDown={(e) => handleClick("경북", e)}
                            x="331.5" y="336" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 전북 */}
                    <g
                        className={'local jeonbuk ' + (selectedRegion === "전북" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("전북", e)}
                            onKeyDown={(e) => handleClick("전북", e)}
                            x="65" y="391" width="187" height="138" viewBox="0 0 187 138" fill="none">
                            <path d="M11.5115 128.51L11.6009 128.646L11.7292 128.747L21.1841 136.192L21.4563 136.407H21.8028H38.34H38.9624L39.2373 135.848L51.292 111.351L64.4085 109.645L68.6499 116.152L69.0159 116.714L69.6742 116.589L79.3611 114.75L79.6371 114.698L79.8454 114.509L87.1881 107.867L93.4818 112.909L92.2831 119.663L92.0797 120.81L93.2438 120.838L106.585 121.158L117.784 122.696L126.543 124.914L127.057 125.044L127.453 124.691L135.595 117.443L143.654 119.936L143.78 119.975L143.911 119.98L158.111 120.534L158.819 120.561L159.08 119.902L164.556 106.065L164.691 105.726L164.575 105.38L155.756 79.0255L163.125 54.6327L174.775 49.9378L174.991 49.8509L175.146 49.6777L184.94 38.7509L185.241 38.4149L185.189 37.9667L182.727 17.0415L182.646 16.3539L181.974 16.1876L152.021 8.77815L151.475 8.64296L151.076 9.04008L138.702 21.3539H120.248L118.376 8.65675L118.288 8.0592L117.718 7.85909L108.21 4.52034L107.762 4.36308L107.357 4.61065L95.4372 11.897L86.9247 10.4744L84.0068 4.16904L83.7836 3.68666L83.2588 3.60184L73.4293 2.01282L73.0876 1.95757L72.7848 2.12543L51.4774 13.939L35.611 22.2355L35.2679 22.4149L35.1351 22.7787L2.06067 113.353L1.88854 113.824L2.16358 114.244L11.5115 128.51Z" 
                                // fill={selectedRegion === "전북" ? "#024383" : "#8FC4E7"} 
                                fill="currentColor"
                                stroke="white" strokeWidth="2"/>
                            <text
                                x="37%"
                                y="45%"
                                fontSize="16px"
                                fill={selectedRegion === "전북" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                전북
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("전북", e)}
                            onKeyDown={(e) => handleClick("전북", e)}
                            x="118" y="440.5" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 대구 */}
                    <g
                        className={'local daegu ' + (selectedRegion === "대구" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("대구", e)}
                            onKeyDown={(e) => handleClick("대구", e)}
                            x="352" y="421" width="32" height="55" viewBox="0 0 32 55" fill="none">
                            <path d="M8.57776 53.0136L8.81072 53.7341L9.56737 53.7052L15.6506 53.4731L16.3473 53.4466L16.5633 52.7837L19.7744 42.9281L19.7881 42.8863L19.798 42.8435L24.1595 23.9691L30.4303 15.1862L30.7362 14.7579L30.5563 14.2633L25.9715 1.65819L25.7321 1H25.0318H11.0635H10.5162L10.2212 1.46098L5.42234 8.95976L5.30509 9.14298L5.27454 9.35834L2.00991 32.3724L1.9775 32.6009L2.0485 32.8205L8.57776 53.0136Z"
                                // fill={selectedRegion === "대구" ? "#024383" : "#2D8DD2"} 
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("대구", e)}
                            onKeyDown={(e) => handleClick("대구", e)}
                            x="360.5" y="435" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 전남 */}
                    <g
                        className={'local jeonnam ' + (selectedRegion === "전남" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("전남", e)}
                            onKeyDown={(e) => handleClick("전남", e)}
                            x="43" y="497" width="215" height="194" viewBox="0 0 215 194" fill="none">
                            <path d="M212.601 79.7514L213.168 79.1007L212.607 78.4448L202.716 66.8751L198.242 49.0877L198.141 48.6885L197.789 48.4756L185.401 40.9952L180.666 15.2457L180.521 14.4609L179.724 14.4274L165.386 13.8258L157.767 11.4716L157.229 11.3051L156.807 11.68L148.677 18.915L139.576 16.5999L139.521 16.5859L139.464 16.5782L128.333 15.0606L128.277 15.0531L128.222 15.0517L114.008 14.7052L115.285 7.51346L115.389 6.92874L114.925 6.55775L109.502 2.21913L108.837 1.68692L108.206 2.25917L101.207 8.6048L90.7789 10.5872L86.5243 4.04393L86.1812 3.51613L85.5568 3.59742L73.3546 5.18642L72.8232 5.25563L72.5865 5.73649L60.4986 30.2989H43.2093L33.7805 22.6144L32.9439 21.9326L32.3277 22.8186L13.5784 49.7784L13.4606 49.9479L13.4195 50.1502L2.02003 106.248L1.97741 106.458L2.02436 106.667L7.57243 131.341L7.64185 131.65L7.87625 131.862L32.6639 154.345L32.5412 179.77L32.5381 180.419L33.1306 180.686L59.3368 192.488L59.8198 192.705L60.2711 192.428L100.142 167.914L100.484 167.704L100.586 167.315L108.74 136.143L122.278 122.936L138.876 125.439L133.52 143.17L133.286 143.942L133.991 144.333L146.979 151.546L147.455 151.811L147.935 151.554L182.686 133.004L183.738 132.442L183.002 131.504L160.288 102.566L172.421 93.113L187.12 107.397L187.877 108.132L188.571 107.336L212.601 79.7514ZM96.7251 60.5546L96.6922 70.3702L94.5518 78.3955L85.2571 78.363L80.2858 76.7508L80.0565 76.6764L79.8184 76.7147L69.3603 78.3984L60.5333 74.3636V64.3325L69.3709 55.4876L78.4762 58.0432L78.6069 58.0799L78.7426 58.0804L87.9032 58.1156L96.7251 60.5546Z"
                                // fill={selectedRegion === "전남" ? "#024383" : "#67ADDD"}
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                            <text
                                x="57%"
                                y="37%"
                                fontSize="16px"
                                fill={selectedRegion === "전남" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                전남
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("전남", e)}
                            onKeyDown={(e) => handleClick("전남", e)}
                            x="150" y="557" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 광주 */}
                    <g
                        className={'local gwangju ' + (selectedRegion === "광주" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("광주", e)}
                            onKeyDown={(e) => handleClick("광주", e)}
                            x="101" y="550" width="39" height="28" viewBox="0 0 39 28" fill="none">
                            <path d="M10.6547 2.03831L10.0816 1.87496L9.66524 2.30118L1.2847 10.8793L1 11.1707V11.5781V21.1176V21.7531L1.57529 22.023L9.81164 25.8868L10.0936 26.0191L10.4008 25.9679L20.916 24.2153L26.1418 25.9491L26.2952 26H26.4567H34.9634H35.7355L35.9309 25.2531L37.9674 17.47L38 17.3455V17.2168V7.93611V7.18026L37.2728 6.97404L28.9283 4.60766L28.7965 4.57027L28.6594 4.56973L19.4074 4.53332L10.6547 2.03831Z"
                                // fill={selectedRegion === "광주" ? "#024383" : "#2D8DD2"}
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("광주", e)}
                            onKeyDown={(e) => handleClick("광주", e)}
                            x="110" y="557" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 경남 */}
                    <g
                        className={'local gyeongnam ' + (selectedRegion === "경남" ? "active" : "")}
                    >
                        <svg
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("경남", e)}
                            onKeyDown={(e) => handleClick("경남", e)}
                            x="219" y="428" width="203" height="150" viewBox="0 0 203 150" fill="none">
                            <path d="M178.614 121.45L179.253 121.204L179.255 120.52L179.308 105.769L201.156 72.809L201.508 72.2772L201.175 71.7334L185.927 46.8889V38.8334V37.5154L184.658 37.8703L173.211 41.0711L164.497 39.1948L164.014 39.0908L163.638 39.4116L154.963 46.8113L133.479 47.6978L115.324 39.3706L114.979 39.2124L114.616 39.3228L93.2083 45.8321H70.2376L67.1212 39.4389L71.3955 28.9076L71.6396 28.3062L71.1898 27.8384L66.6407 23.1071L66.482 22.9421L66.2674 22.8625L49.234 16.5493L32.2774 2.23585L31.5355 1.60958L30.8876 2.33269L21.2845 13.0506L9.81522 17.6772L9.37078 17.8565L9.2321 18.3152L2.04278 42.097L1.95072 42.4016L2.05156 42.7033L10.8736 69.1032L5.15627 83.5655L5.05079 83.8323L5.10281 84.1144L9.86595 109.949L9.94744 110.391L10.3321 110.624L22.682 118.089L27.2019 136.008L27.2591 136.235L27.4111 136.413L37.1693 147.84L37.4642 148.185L37.9183 148.19L75.4525 148.619L75.5312 148.62L75.6091 148.608L126.719 141.11L127.221 141.036L127.458 140.588L138.443 119.848L171.257 124.15L171.509 124.183L171.746 124.092L178.614 121.45Z"
                                // fill={selectedRegion === "경남" ? "#024383" : "#BADBF0"}
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                            <text
                                x="32%"
                                y="60%"
                                fontSize="16px"
                                fill={selectedRegion === "경남" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                경남
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("경남", e)}
                            onKeyDown={(e) => handleClick("경남", e)}
                            x="266" y="506" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 울산 */}
                    <g
                        className={'local ulsan ' + (selectedRegion === "울산" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("울산", e)}
                            onKeyDown={(e) => handleClick("울산", e)}
                            x="403" y="451" width="63" height="57" viewBox="0 0 63 57" fill="none">
                            <path
                                tabIndex="0"
                                d="M1 24.4252V24.7075L1.14762 24.9481L16.329 49.6941L16.6212 50.1703L17.1799 50.1712L29.2398 50.1888L49.0458 55.2287L50.0528 55.4849L50.2703 54.4689L61.0275 4.20929L61.4072 2.43528L59.7045 3.06145L45.3273 8.34869L29.382 10.9193L23.9192 6.18993L23.6932 5.99424L23.3968 5.95473L12.5504 4.50855L12.054 4.44236L11.7037 4.80023L1.50814 15.2149L1 15.3841V16.1051V24.4252Z"
                                // fill={selectedRegion === "울산" ? "#024383" : "#2D8DD2"}
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                            <text
                                x="42%"
                                y="50%"
                                fontSize="16px"
                                fill={selectedRegion === "울산" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                울산
                            </text>
                        </svg>
                        <svg
                            className="point"
                            onClick={(e) => handleClick("울산", e)}
                            onKeyDown={(e) => handleClick("울산", e)}
                            x="413" y="468" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 제주 */}
                    <g
                        className={'local jeju ' + (selectedRegion === "제주" ? "active" : "")}
                    >
                        <svg 
                            tabIndex="0"
                            role="button"
                            onClick={(e) => handleClick("제주", e)}
                            onKeyDown={(e) => handleClick("제주", e)}
                            x="92" y="710" width="79" height="52" viewBox="0 0 79 52" fill="none">
                            <path
                                tabIndex="0"
                                d="M28.3678 2.00144L27.9904 1.98119L27.694 2.21561L6.78609 18.7486L6.52175 18.9576L6.43785 19.284L2.03149 36.424L1.8683 37.0588L2.38527 37.4617L20.8491 51.8522L21.216 52.1382L21.6711 52.0418L56.904 44.5787L57.2139 44.5131L57.4294 44.2811L77.5167 22.6597L77.8296 22.3229L77.7777 21.8661L75.9045 5.38664L75.809 4.54632L74.9645 4.50101L28.3678 2.00144Z"
                                // fill={selectedRegion === "제주" ? "#024383" : "#67ADDD"}
                                fill="currentColor"
                                stroke="white" strokeWidth="2"
                            />
                            <text
                                x="38%"
                                y="62.5%"
                                fontSize="16px"
                                fill={selectedRegion === "제주" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                제주
                            </text>
                        </svg>
                        <svg 
                            className="point"
                            onClick={(e) => handleClick("제주", e)}
                            onKeyDown={(e) => handleClick("제주", e)}
                            x="106" y="730"width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" fill="white" />
                        </svg>
                    </g>
                    {/* 그 외 */}
                    <g>
                        {/* 서울 */}
                        <svg x="120.5" y="145" width="51" height="39" viewBox="0 0 51 39" fill="none">
                            <path d="M39.3638 5.671L25.9485 0.421875L8.10903 7.47428L2.61446 9.90245L0.366699 10.7595L0.616451 18.6153L6.75322 22.2933L13.5679 33.6664L24.6284 38.8977L43.7166 37.4872L50.3529 23.0253L44.6264 18.4903L39.3638 5.671Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 안면도 */}
                        <svg x="53" y="319" width="18" height="31" viewBox="0 0 18 31" fill="none">
                            <path d="M3.19432 0.322388L0.179443 6.73204L3.71166 23.8721L12.3995 30.9245L17.3767 28.407L15.8247 15.6413L3.19432 0.322388Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 세종 */}
                        <svg x="172.5" y="312" width="20" height="27" viewBox="0 0 20 27" fill="none">
                            <path d="M19.7952 22.2129L13.3552 26.1944L8.71692 15.6426L0.742676 5.57283L5.61285 0.484375L16.0133 2.94826L16.4771 3.12682L19.7952 22.2129Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 대전 */}
                        <svg x="182" y="335" width="32" height="29" viewBox="0 0 32 29" fill="none">
                            <path d="M11.2579 0.320312L3.71176 5.06951L0.821777 14.8179L2.24893 22.4238L10.5264 28.0479H27.8129L31.3273 22.4417L24.0488 8.7475L11.2579 0.320312Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 울릉도 */}
                        <svg x="477.5" y="157" width="33" height="26" viewBox="0 0 33 26" fill="none">
                            <path d="M13.1574 0.902344L2.16831 12.9718L0.580566 21.6668L8.89377 24.3806L21.9879 25.1305L32.4419 12.1684V3.86615L13.1574 0.902344Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 독도 */}
                        <svg x="529" y="169" width="11" height="9" viewBox="0 0 11 9" fill="none">
                            <path d="M3.22309 0.0078125L0.226074 6.25678L1.72458 8.6671L7.86137 8.95276L12.0001 3.25728L3.22309 0.0078125Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 부산 */}
                        <svg x="398.5" y="502.5" width="54" height="48" viewBox="0 0 54 48" fill="none">
                            <path d="M33.7529 0.0976562H21.8897L0.107666 32.9315V47.1077L33.9313 35.6096L53.3228 5.06112L33.7529 0.0976562Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 진도 */}
                        <svg x="30" y="642.5" width="31" height="37" viewBox="0 0 31 37" fill="none">
                            <path d="M13.7602 0.554688L0.166504 16.8913V31.4067L13.7602 36.9594L28.4064 27.1039L30.7255 9.57104L13.7602 0.554688Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 다도해 */}
                        <svg x="0" y="670" width="20" height="17" viewBox="0 0 20 17" fill="none">
                            <path d="M18.3033 1.90715L19.0882 16.7619H4.79882L0 9.95941L9.54412 0.835938L18.3033 1.90715Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    <g>
                        {/* 거제도 */}
                        <svg x="342" y="564" width="31" height="46" viewBox="0 0 31 46" fill="none">
                            <path d="M19.8382 0.388672L2.99769 21.2781L0.3396 29.7589L9.61615 45.9169H23.4953L30.7916 28.0984V12.8509L19.8382 0.388672Z" fill="#E3F1F9"/>
                        </svg>
                    </g>
                    {/*--- 지역명 ---*/}
                    <g>
                        {/* 인천 */}
                        <svg x="63" y="182" width="35" height="24" viewBox="0 0 35 24" fill="none">
                            <text
                                onClick={(e) => handleClick("인천", e)}
                                onKeyDown={(e) => handleClick("인천", e)}
                                x="5%"
                                y="80%"
                                fontSize="16px"
                                fill={selectedRegion === "인천" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                인천
                            </text>
                        </svg>
                    </g>
                    <g>
                        {/* 대구 */}
                        <svg x="318" y="428" width="35" height="24" viewBox="0 0 35 24" fill="none">
                            <text
                                onClick={(e) => handleClick("대구", e)}
                                onKeyDown={(e) => handleClick("대구", e)}
                                x="5%"
                                y="80%"
                                fontSize="16px"
                                fill={selectedRegion === "대구" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                대구
                            </text>
                        </svg>
                    </g>
                    <g>
                        {/* 광주 */}
                        <svg x="73" y="572" width="35" height="24" viewBox="0 0 35 24" fill="none">
                            <text
                                onClick={(e) => handleClick("광주", e)}
                                onKeyDown={(e) => handleClick("광주", e)}
                                x="5%"
                                y="80%"
                                fontSize="16px"
                                fill={selectedRegion === "광주" ? "none" : "#161616"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                광주
                            </text>
                        </svg>
                    </g>
                    {/*--- 푯말 ---*/}
                    {/* 인천 */}
                    <g>
                        <svg x="58" y="87" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M8 38.8608C8 21.8165 21.6554 8 38.4989 8C55.3425 8 69 21.8165 69 38.8608C69 55.9052 55.7024 69.3532 39.1655 69.7131V80L20.9377 64.0934C13.1112 58.506 8 49.2878 8 38.8608Z" fill={selectedRegion === "인천" ? "#894BEC" : "none" } stroke={selectedRegion === "인천" ? "white" : "none" } strokeWidth="1"/>
                                <path d="M38.1655 69.7131V68.7346L39.1438 68.7133C55.1323 68.3654 68 55.366 68 38.8608C68 22.3577 54.7792 9 38.4989 9C22.2188 9 9 22.3576 9 38.8608C9 48.9541 13.9463 57.8735 21.5187 63.2795L21.5585 63.3078L21.5952 63.3399L38.1655 77.8001V69.7131Z" stroke={selectedRegion === "인천" ? "white" : "none" } strokeWidth="2"/>

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "인천" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                인천
                            </text>
                        </svg>
                    </g>
                    {/* 경기 */}
                    <g>
                        <svg 
                            onClick={(e) => handleClick("경기", e)}
                            onKeyDown={(e) => handleClick("경기", e)}
                            x="150" y="120" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "경기" ? "#894BEC" : "none" } stroke={selectedRegion === "경기" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "경기" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "경기" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                경기
                            </text>
                        </svg>
                    </g>
                    {/* 강원 */}
                    <g>
                        <svg 
                            onClick={(e) => handleClick("강원", e)}
                            onKeyDown={(e) => handleClick("강원", e)}
                            x="253" y="42" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "강원" ? "#894BEC" : "none" } stroke={selectedRegion === "강원" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "강원" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "강원" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                강원
                            </text>
                        </svg>
                    </g>
                    {/* 충남 */}
                    <g>
                        <svg
                            onClick={(e) => handleClick("충남", e)}
                            onKeyDown={(e) => handleClick("충남", e)}
                            x="85" y="240" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "충남" ? "#894BEC" : "none" } stroke={selectedRegion === "충남" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "충남" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "충남" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                충남
                            </text>
                        </svg>
                    </g>
                    <g>
                        {/* 충북 */}
                        <svg x="187" y="198" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "충북" ? "#894BEC" : "none" } stroke={selectedRegion === "충북" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "충북" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "충북" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                충북
                            </text>
                        </svg>
                    </g>
                    {/* 경북 */}
                    <g>
                        <svg
                            onClick={(e) => handleClick("경북", e)}
                            onKeyDown={(e) => handleClick("경북", e)}
                            x="310" y="248" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "경북" ? "#894BEC" : "none" } stroke={selectedRegion === "경북" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "경북" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "경북" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                경북
                            </text>
                        </svg>
                    </g>
                    {/* 전북 */}
                    <g>
                        <svg x="95" y="352" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "전북" ? "#894BEC" : "none" } stroke={selectedRegion === "전북" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "전북" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "전북" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                전북
                            </text>
                        </svg>
                    </g>
                    {/* 경남 */}
                    <g>
                        <svg x="240" y="422" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "경남" ? "#894BEC" : "none" } stroke={selectedRegion === "경남" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "경남" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "경남" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                경남
                            </text>
                        </svg>
                    </g>
                    {/* 대구 */}
                    <g>
                        <svg x="320" y="350" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M8 38.8608C8 21.8165 21.6554 8 38.4989 8C55.3425 8 69 21.8165 69 38.8608C69 55.9052 55.7024 69.3532 39.1655 69.7131V80L20.9377 64.0934C13.1112 58.506 8 49.2878 8 38.8608Z" fill={selectedRegion === "대구" ? "#894BEC" : "none" } stroke={selectedRegion === "대구" ? "white" : "none" } strokeWidth="1"/>
                                <path d="M38.1655 69.7131V68.7346L39.1438 68.7133C55.1323 68.3654 68 55.366 68 38.8608C68 22.3577 54.7792 9 38.4989 9C22.2188 9 9 22.3576 9 38.8608C9 48.9541 13.9463 57.8735 21.5187 63.2795L21.5585 63.3078L21.5952 63.3399L38.1655 77.8001V69.7131Z" stroke={selectedRegion === "대구" ? "white" : "none" } strokeWidth="2"/>

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "대구" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                대구
                            </text>
                        </svg>
                    </g>
                    {/* 울산 */}
                    <g>
                        <svg x="388" y="383" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "울산" ? "#894BEC" : "none" } stroke={selectedRegion === "울산" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "울산" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "울산" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                울산
                            </text>
                        </svg>
                    </g>
                    {/* 광주 */}
                    <g>
                        <svg x="70" y="472" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M8 38.8608C8 21.8165 21.6554 8 38.4989 8C55.3425 8 69 21.8165 69 38.8608C69 55.9052 55.7024 69.3532 39.1655 69.7131V80L20.9377 64.0934C13.1112 58.506 8 49.2878 8 38.8608Z" fill={selectedRegion === "광주" ? "#894BEC" : "none" } stroke={selectedRegion === "광주" ? "white" : "none" } strokeWidth="1"/>
                                <path d="M38.1655 69.7131V68.7346L39.1438 68.7133C55.1323 68.3654 68 55.366 68 38.8608C68 22.3577 54.7792 9 38.4989 9C22.2188 9 9 22.3576 9 38.8608C9 48.9541 13.9463 57.8735 21.5187 63.2795L21.5585 63.3078L21.5952 63.3399L38.1655 77.8001V69.7131Z" stroke={selectedRegion === "광주" ? "white" : "none" } strokeWidth="2"/>

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "광주" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                광주
                            </text>
                        </svg>
                    </g>
                    {/* 전남 */}
                    <g>
                        <svg x="125" y="472" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "전남" ? "#894BEC" : "none" } stroke={selectedRegion === "전남" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "전남" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "전남" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                전남
                            </text>
                        </svg>
                    </g>
                    {/* 제주 */}
                    <g>
                        <svg x="80" y="645" width="85" height="96" viewBox="0 0 85 96" fill="none">
                            <g filter="url(#filter0_d_635_6865)">
                                <path d="M69 38.8618C69 21.8169 55.3446 8 38.5011 8C21.6575 8 8 21.8169 8 38.8618C8 55.9066 21.2976 69.355 37.8345 69.7149V80.0022L56.0623 64.0951C63.8888 58.5075 69 49.2891 69 38.8618Z" fill={selectedRegion === "제주" ? "#894BEC" : "none" } stroke={selectedRegion === "제주" ? "white" : "none" } strokeWidth="1" />
                                <path d="M38.8345 69.7149V68.7364L37.8562 68.7151C21.8677 68.3672 9 55.3675 9 38.8618C9 22.3581 22.2208 9 38.5011 9C54.7812 9 68 22.358 68 38.8618C68 48.9553 63.0537 57.8751 55.4812 63.2812L55.4415 63.3095L55.4048 63.3416L38.8345 77.8022V69.7149Z" stroke={selectedRegion === "제주" ? "white" : "none" } strokeWidth="2" />

                            </g>
                            <text
                                x="27%"
                                y="48%"
                                fontSize="16px"
                                fill={selectedRegion === "제주" ? "#ffffff" : "none"}
                                paintOrder="stroke"
                                fontWeight="bold"
                            >
                                제주
                            </text>
                        </svg>
                    </g>
                </svg>
            </div>
        </>
    );
};

export default LocalMap;